angular.module('mtic').service('userAccount', function ($log,EventManager, $location, LoginCookie, $cookies, IAMManager, LOGIN_CONSTANTS, DEV_VARIABLES, $timeout, $window, language, PlatformService) {
  var eventManager = new EventManager('userAccount');
  /**
  * Private loginInfo
  * @type {Object}
  */
  var loginInfo = {
    userData: {},
    isLoggedin: false
  };
  var languageSetThroughProfile = false;
  /**
  * Resets login (in cases where the session expires)
  * @return {}
  */
  var resetLogin = function () {
    var uuid = (loginInfo && loginInfo.userData) ? (loginInfo.userData.uuid || '') : '';
    loginInfo.userData = {
      uuid: uuid,
      user_id: null,
      firstName: null,
      lastName: null,
      fullName: null,
      role: {},
      roles: [],
      sessionKey: null,
      firebase_token: null
    }
    loginInfo.isLoggedin = false;
  }
  resetLogin();

  /**
  * Capitalize the first letter in a string
  * @param  {String} string
  * @return {String}
  */
  var capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  /**
  * @param  {Determine if admin}
  * @return {Boolean}
  */
  var isAdmin = function(roles) {
    var isAdmin = false;
    var roleIndex = 0;
    var role;
    while (!isAdmin) {
      role = roles[roleIndex]
      isAdmin = role.role_type === 'admin' && role.group_id === 1
      roleIndex++;
      if(roleIndex > roles.length - 1) {
        break;
      }
    }
    return isAdmin;
  }

  /**
  * Determine the user role
  * @param  {Array<Role>} roles
  * @return {Promise}
  */
  var determineRole = function (roles) {
    if (roles.length === 0) {
      throw new Error('User has no role assigned to them')
    }
    else if (roles.length > 1) {
      // Teacher
      var isTeacher = false;
      var roleIndex = 0;
      var role;
      while (!isTeacher) {
        role = roles[roleIndex]
        isTeacher = role.role_type === LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER &&
        role.group.group_type === LOGIN_CONSTANTS.GROUP_TYPES.SCHOOL
        roleIndex++;
        if(roleIndex > roles.length - 1) {
          break;
        }
      }
      if(isTeacher) {
        // throw new Error('Student has more than one role assigned to them, or this is a teacher without a school assigned to them, this is not supported in this release')
        return angular.extend(role, {
          isGeneralAccess: false,
          isTeacher: true
        });
      }
      else{
        return angular.extend(roles[0], {
          isGeneralAccess: false,
          isTeacher: false
        });
      }
    }
    else {
      return angular.extend(roles[0], {
        isGeneralAccess: false,
        isTeacher: (roles[0].role_type === LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER)
      });
    }
  }
  /**
  * Public Methods
  * @type {Object}
  */
  return {
    determineRole,
    isLoggedIn() {
      return loginInfo.isLoggedin
    },
    expireSession() {
      resetLogin();
      LoginCookie.clearSessions();
      eventManager.broadcast('login:session:expired')
      eventManager.clearLoginSession()
    },
    logout() {

      if(window.isWebEmbedConnect){
        $cookies.putObject('webembedcookie', ['true'], {
          'expires': moment().add(1, 'hours').toDate()
        })
      }

      eventManager.broadcast('logging-out');

      if(loginInfo.loggedInFromSaml || window.location.href.indexOf('force-saml') > -1){
          resetLogin();
          LoginCookie.clearSessions();
          eventManager.clearLoginSession();
          EventManager.disableBeforeUnloadMsg = true;
          eventManager.broadcast('logout', {})
      }else{
        IAMManager.logout().then((atLeastOneLoggedOut) => {
          resetLogin();
          LoginCookie.clearSessions();
          eventManager.clearLoginSession();
          EventManager.disableBeforeUnloadMsg = true;
          IAMManager.clearSavedUrlParamsForToken();
          if(!atLeastOneLoggedOut || PlatformService.isApp){
            eventManager.broadcast('logout', {})
          }
        })
      }



    },
    clearSession() {
      resetLogin();
      LoginCookie.clearSessions();
      eventManager.broadcast('login:session:clear')
      eventManager.clearLoginSession()
    },
    getActiveClassroom(class_id) {
      return loginInfo.activeClassroom;
    },
    setActiveClassroom(class_id) {
      loginInfo.activeClassroom = class_id;
    },
    setActiveClassFull(class_data){
      loginInfo.fullClass = class_data;
    },
    setData(uuid, userData) {
      loginInfo.userData = {
        uuid: uuid,
        user_id: userData.user_id,
        firstName: capitalizeFirstLetter(userData.info.first_name),
        lastName: capitalizeFirstLetter(userData.info.last_name),
        fullName: capitalizeFirstLetter(userData.info.first_name) + ' ' + capitalizeFirstLetter(userData.info.last_name),
        role: determineRole(userData.roles),
        isAdmin: isAdmin(userData.roles),
        roles: userData.roles,
        sessionKey: userData.session_key,
        firebase_token: userData.firebaseToken
      };
      const role = loginInfo.userData.role.role_type;
      LoginCookie.registerLogin(uuid, loginInfo.userData.fullName, userData.user_id, userData.session_key, userData.firebaseToken, role)
      loginInfo.isLoggedin = true;
      loginInfo.loggedInFromSaml = !!userData.loggedInFromSaml;
      eventManager.broadcast('userAccount:setData', loginInfo.userData.role)
      eventManager.setUserInfo(loginInfo.userData.user_id);
      if(userData.info.language){
        languageSetThroughProfile = true;
        language.set(userData.info.language, true)
      }
      return loginInfo.userData.role;
    },
    getData(data) {
      return loginInfo.userData;
    },
    getActiveClassData(){
      return loginInfo.fullClass;
    },
    isSamlUser(){
      return loginInfo.loggedInFromSaml;
    },
    setIsSamlUser (isSamlUser) {
      loginInfo.loggedInFromSaml = isSamlUser;
    },
    isLanguageSetThroughProfile(){
      return languageSetThroughProfile;
    }
  }
});
